document.addEventListener("DOMContentLoaded", () => {
  const openModalBtn = document.getElementById("open-color-picker");
  const modal = document.getElementById("color-picker-modal");
  const modalContent = modal ? modal.querySelector(".color-picker-modal-content") : null;

  const closeModalBtn = document.getElementById("close-color-picker");
  const confirmBtn = document.getElementById("confirm-color");
  const colorList = document.getElementById("color-list");
  const selectedColorName = document.getElementById("selected-color-label-name");
  const modalSelectedColorInfo = document.getElementById("modal-selected-color-info");
  const searchInput = document.getElementById("color-search");
  const toggleSearchButton = document.getElementById("toggle-search");
  const resetColorButton = document.getElementById("reset-color-button");
  const clearSearchButton = document.getElementById("clear-color-search");

  const selectedColorPropertyInput = document.getElementById("selected-color-property");
  const selectedColorIdInput = document.getElementById("selected-color-id");
  const selectedColorHexInput = document.getElementById("selected-color-hex"); // NEU
  const radioButtons = document.querySelectorAll('input[name="Farbe"]');

  const tonePreviewBox = document.getElementById("tone-preview-box");
  const expandToneBtn = document.getElementById("expand-tone-preview");

  const wallOverlayExterior = document.getElementById("wall-overlay");
  const wallOverlayInterior = document.getElementById("wall-overlay-interior");

  const familyFilterButtons = document.querySelectorAll(".tone-family-filter");
  const previewTabs = document.querySelectorAll(".preview-tab");
  const previewItems = document.querySelectorAll(".preview-item");
  const categoryContainer = document.getElementById("color-categories");

  // Mobile Tabs & Panels
  const mobileTabButtons = document.querySelectorAll(".mobile-tab-button");
  const sidebarPanel = document.querySelector(".sidebar-panel");
  const tonesPanel = document.querySelector(".tones-panel");
  const previewPanel = document.querySelector(".preview-panel");
  const toneFilterBlock = document.querySelector(".tone-filter-block");
  const collectionBlock = document.querySelector(".collection-block");

  // Vollflächen-Popup
  const toneFullscreenPopup = document.getElementById("tone-fullscreen-popup");
  const toneFullscreenClose = document.getElementById("tone-fullscreen-close");

  // Vorschläge unter der Suche
  let suggestionsContainer = null;

  /* ===========================
     Shopify Chat ausblenden
     =========================== */
  let chatWidget = null;
  let chatOriginalDisplay = null;

  function findChatWidget() {
    if (chatWidget) return;

    chatWidget =
      document.querySelector("#shopify-chat") ||
      document.querySelector('[id*="shopify-chat"]') ||
      document.querySelector("div[data-shopify-chat]") ||
      document.querySelector('iframe[src*="shopify"]') ||
      document.querySelector('iframe[src*="inbox"]') ||
      document.querySelector('iframe[src*="chat"]');
  }

  function hideChatWidget() {
    findChatWidget();
    if (!chatWidget) return;

    if (chatOriginalDisplay === null) {
      chatOriginalDisplay = chatWidget.style.display || "";
    }
    chatWidget.style.display = "none";
  }

  function showChatWidget() {
    if (!chatWidget) return;
    chatWidget.style.display = chatOriginalDisplay !== null ? chatOriginalDisplay : "";
  }

  /* ===========================
     Trusted Shops Trustbadge ausblenden
     =========================== */

  let trustWidgets = [];
  const trustOriginalDisplay = new WeakMap();
  let trustObserver = null;

  function collectTrustWidgets() {
    const selectors = [
      "#trustbadge",
      '[id*="trustbadge"]',
      '[class*="trustbadge"]',
      "[data-ts-widget]",
      "[data-ts-rating]",
      "[data-ts-experience]",
      'iframe[src*="trustedshops"]',
      'iframe[src*="trustbadge"]',
      'iframe[src*="tsbadge"]'
    ];

    const found = Array.from(document.querySelectorAll(selectors.join(",")));

    found.forEach((el) => {
      if (!trustWidgets.includes(el)) {
        trustWidgets.push(el);
      }
    });
  }

  function hideTrustWidgets() {
    collectTrustWidgets();
    if (!trustWidgets.length) return;

    trustWidgets.forEach((el) => {
      if (!trustOriginalDisplay.has(el)) {
        trustOriginalDisplay.set(el, el.style.display || "");
      }
      el.style.display = "none";
    });
  }

  function showTrustWidgets() {
    trustWidgets.forEach((el) => {
      const orig = trustOriginalDisplay.get(el);
      el.style.display = orig !== undefined ? orig : "";
    });
  }

  function startTrustObserver() {
    if (trustObserver) return;

    trustObserver = new MutationObserver(() => {
      if (document.body.classList.contains("fh-colorpicker-open")) {
        hideTrustWidgets();
      }
    });

    trustObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function stopTrustObserver() {
    if (trustObserver) {
      trustObserver.disconnect();
      trustObserver = null;
    }
  }

  /* ===========================
     Allgemeine State-Variablen
     =========================== */

  let colors = [];
  let tempSelectedColor = null;
  let selectedFamily = "all";
  let selectedCategory = "all";

  // Verfügbarkeits-Check für eine Preisgruppe auf Basis der Varianten
  function isPriceGroupAvailableForProduct(priceGroup) {
    // Wenn du in colors.json priceGroup = "0" setzt → immer nicht verfügbar
    if (String(priceGroup) === "0") return false;

    let foundAvailable = false;

    radioButtons.forEach((radio) => {
      const group = (radio.dataset.priceGroup || "").trim();

      // Variante 1: "PG1", "PG2" usw.
      // Variante 2: direkt gleiche Bezeichnung wie im JSON
      if (group === `PG${priceGroup}` || group === String(priceGroup)) {
        const disabled = radio.classList.contains("is-disabled") || radio.disabled;
        if (!disabled) {
          foundAvailable = true;
        }
      }
    });

    return foundAvailable;
  }

  // Grundcheck – wenn das Picker-HTML nicht da ist, JS nicht ausführen
  if (
    !openModalBtn ||
    !modal ||
    !modalContent ||
    !confirmBtn ||
    !colorList ||
    !selectedColorName ||
    !modalSelectedColorInfo ||
    !searchInput ||
    !toggleSearchButton
  ) {
    console.warn("Color Picker: DOM-Elemente fehlen – Picker wird hier nicht initialisiert.");
    return;
  }

  function validateDOMElements() {
    const missing = [];
    if (!selectedColorName) missing.push("selectedColorName");
    if (!modalSelectedColorInfo) missing.push("modalSelectedColorInfo");
    if (!searchInput) missing.push("searchInput");
    if (!toggleSearchButton) missing.push("toggleSearchButton");
    if (!modal) missing.push("modal");
    if (!modalContent) missing.push("modalContent");
    if (!confirmBtn) missing.push("confirmBtn");
    if (!colorList) missing.push("colorList");

    if (missing.length > 0) {
      console.error("Fehlende DOM-Elemente:", missing.join(", "));
      return false;
    }
    return true;
  }

  /* ===========================
     Helper: Suche normalisieren
     =========================== */

  function normalizeSearchString(str) {
    return (str || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[-_]/g, "");
  }

  /* ===========================
     Helper: Suche komplett resetten
     =========================== */

  function resetSearchAndShowAll() {
    if (!searchInput) return;

    // Suche leeren
    searchInput.value = "";
    renderSuggestions("");

    // X-Button verstecken
    if (clearSearchButton) {
      clearSearchButton.classList.add("hidden");
    }

    // Kollektionen auf "Alle"
    selectedCategory = "all";
    if (categoryContainer) {
      const catButtons = categoryContainer.querySelectorAll(".category-button");
      catButtons.forEach((btn) => {
        btn.classList.toggle("active", btn.dataset.category === "all");
      });
    }

    // Alle Farben ohne Suche anzeigen
    renderColors("");
  }

  /* ===========================
     Farb-Helfer: HEX -> HSL & Farbfamilien
     =========================== */

  function hexToHsl(hex) {
    let r = 0,
      g = 0,
      b = 0;
    const cleaned = (hex || "").replace("#", "");

    if (cleaned.length === 3) {
      r = parseInt(cleaned[0] + cleaned[0], 16);
      g = parseInt(cleaned[1] + cleaned[1], 16);
      b = parseInt(cleaned[2] + cleaned[2], 16);
    } else if (cleaned.length === 6) {
      r = parseInt(cleaned.substring(0, 2), 16);
      g = parseInt(cleaned.substring(2, 4), 16);
      b = parseInt(cleaned.substring(4, 6), 16);
    }

    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h, s;
    const l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
        default:
          h = (r - g) / d + 4;
          break;
      }
      h *= 60;
    }

    return { h: isNaN(h) ? 0 : h, s: s || 0, l: l || 0 };
  }

  function getColorFamily(color) {
    if (!color || !color.hex) return "Grau - Töne";
    const { h, s, l } = hexToHsl(color.hex);

    if (l > 0.9 && s < 0.15) return "Weiß - Töne";
    if (s < 0.12 && l > 0.2 && l < 0.9) return "Grau - Töne";

    const hue = h;

    if ((hue >= 0 && hue < 20) || (hue >= 340 && hue <= 360)) {
      return "Rot - Töne";
    } else if (hue >= 20 && hue < 45) {
      return "Orange - Töne";
    } else if (hue >= 45 && hue < 70) {
      return "Gelb - Töne";
    } else if (hue >= 70 && hue < 170) {
      return "Grün - Töne";
    } else if (hue >= 170 && hue < 255) {
      return "Blau - Töne";
    } else if (hue >= 255 && hue < 340) {
      return "Violett - Töne";
    }

    return "Grau - Töne";
  }

  /* ===========================
     UI-Updates: Preview & Variant
     =========================== */

  function updatePreviews(color) {
    if (!color) return;

    if (wallOverlayExterior) wallOverlayExterior.style.backgroundColor = color.hex;
    if (wallOverlayInterior) wallOverlayInterior.style.backgroundColor = color.hex;

    if (tonePreviewBox) {
      tonePreviewBox.style.backgroundColor = color.hex;
      tonePreviewBox.dataset.toneName = color.name;
      tonePreviewBox.dataset.priceGroup = color.priceGroup || "";
    }

    // NEU: Hex ins Hidden-Feld schreiben (für Warenkorb-Farbswatch)
    if (selectedColorHexInput) {
      selectedColorHexInput.value = color.hex || "#FFFFFF";
    }
  }

  function updateProductSelectedColorInfo(color) {
    if (!validateDOMElements() || !color) return;

    // Meta-Zeile (Kollektion / Preisgruppe)
    const metaParts = [];

    if (color.category) {
      metaParts.push(color.category);
    }

    if (color.priceGroup && String(color.priceGroup).toLowerCase() !== "weiß") {
      metaParts.push(`PG${color.priceGroup}`);
    }

    const metaHtml =
      metaParts.length > 0
        ? `<div class="fh-selected-color-meta">${metaParts.join(" • ")}</div>`
        : "";

    selectedColorName.innerHTML = `
      <div class="fh-selected-color-card">
        <div class="fh-selected-color-main">
          <span class="color-circle"
                style="
                  background-color:${color.hex};
                  width:18px;height:18px;
                  border-radius:50%;
                  border:1px solid #aaa;
                  display:inline-block;
                "></span>
          <span class="fh-selected-color-name">${color.name}</span>
        </div>
        ${metaHtml}
      </div>
    `;

    if (selectedColorPropertyInput) selectedColorPropertyInput.value = color.name;
    if (selectedColorIdInput) selectedColorIdInput.value = color.id || "";
    if (selectedColorHexInput) selectedColorHexInput.value = color.hex || "#FFFFFF";
  }

  function selectRadioButtonForColor(color) {
    let radioFound = false;

    radioButtons.forEach((radio) => {
      if (
        radio.dataset.priceGroup === `PG${color.priceGroup}` ||
        radio.dataset.priceGroup === String(color.priceGroup)
      ) {
        radio.click();
        radioFound = true;

        if (selectedColorPropertyInput) selectedColorPropertyInput.value = color.name;
        if (selectedColorIdInput) selectedColorIdInput.value = color.id;
        if (selectedColorHexInput) selectedColorHexInput.value = color.hex || "#FFFFFF";
      }
    });

    if (!radioFound) {
      console.warn(`Kein Radio-Button für Preisgruppe PG${color.priceGroup} gefunden.`);
    }
  }

  function updateModalSelectedColorInfo() {
    if (!tempSelectedColor || !modalSelectedColorInfo) return;

    modalSelectedColorInfo.innerHTML = `
      <span class="modal-color-preview"
            style="background:${tempSelectedColor.hex};
                   width:18px;height:18px;border-radius:50%;
                   border:1px solid #2C2D2E;display:inline-block;margin-right:6px;"></span>
      <span class="modal-color-text">
        <strong>${tempSelectedColor.name}</strong> — PG${tempSelectedColor.priceGroup}
      </span>
    `;
  }

  function setDefaultColor() {
    if (!validateDOMElements()) return;

    const defaultColor = {
      name: "weiß",
      priceGroup: "weiß",
      hex: "#FFFFFF",
      id: "default",
      family: "Weiß - Töne"
    };
    tempSelectedColor = defaultColor;

    let defaultRadio = null;
    radioButtons.forEach((radio) => {
      const val = (radio.value || "").toLowerCase();
      if (val === "weiß" || val === "weiss") defaultRadio = radio;
    });
    if (!defaultRadio && radioButtons.length > 0) {
      defaultRadio = radioButtons[0];
    }
    if (defaultRadio) defaultRadio.click();

    // Chips-Highlight zurücksetzen
    document.querySelectorAll(".color-chip").forEach((c) => c.classList.remove("selected"));

    updatePreviews(defaultColor);
    updateModalSelectedColorInfo();
    updateProductSelectedColorInfo(defaultColor);
  }

  /* ===========================
     Vorschlags-Container
     =========================== */

  function ensureSuggestionsContainer() {
    if (suggestionsContainer) return;

    const searchContainer = document.querySelector(".search-container");
    if (!searchContainer) return;

    suggestionsContainer = document.createElement("div");
    suggestionsContainer.className = "color-suggestions hidden";
    searchContainer.style.position = "relative";
    searchContainer.appendChild(suggestionsContainer);
  }

  function renderSuggestions(searchQuery = "") {
    ensureSuggestionsContainer();
    if (!suggestionsContainer) return;

    const rawQ = (searchQuery || "").trim();
    if (!rawQ) {
      suggestionsContainer.classList.add("hidden");
      suggestionsContainer.innerHTML = "";
      return;
    }

    const q = rawQ.toLowerCase();
    const qNorm = normalizeSearchString(rawQ);

    let candidates = colors.filter((color) => {
      const name = color.name || "";
      const id = color.id || "";

      const nameLower = name.toLowerCase();
      const idLower = id.toLowerCase();

      const nameNorm = normalizeSearchString(name);
      const idNorm = normalizeSearchString(id);

      return (
        nameLower.includes(q) ||
        idLower.includes(q) ||
        nameNorm.includes(qNorm) ||
        idNorm.includes(qNorm)
      );
    });

    // Sortierung: exakte Norm-Treffer → startsWith → alphabetisch
    candidates = candidates.sort((a, b) => {
      const aNameNorm = normalizeSearchString(a.name || "");
      const aIdNorm = normalizeSearchString(a.id || "");
      const bNameNorm = normalizeSearchString(b.name || "");
      const bIdNorm = normalizeSearchString(b.id || "");

      const aExact = aNameNorm === qNorm || aIdNorm === qNorm;
      const bExact = bNameNorm === qNorm || bIdNorm === qNorm;
      if (aExact && !bExact) return -1;
      if (!aExact && bExact) return 1;

      const aStarts = aNameNorm.startsWith(qNorm) || aIdNorm.startsWith(qNorm);
      const bStarts = bNameNorm.startsWith(qNorm) || bIdNorm.startsWith(qNorm);
      if (aStarts && !bStarts) return -1;
      if (!aStarts && bStarts) return 1;

      return (a.name || "").localeCompare(b.name || "");
    });

    candidates = candidates.slice(0, 8);

    if (!candidates.length) {
      suggestionsContainer.classList.add("hidden");
      suggestionsContainer.innerHTML = "";
      return;
    }

    suggestionsContainer.innerHTML = "";
    suggestionsContainer.classList.remove("hidden");

    candidates.forEach((color) => {
      const item = document.createElement("div");
      item.className = "color-suggestion-item";

      const swatch = document.createElement("span");
      swatch.className = "color-suggestion-swatch";
      swatch.style.backgroundColor = color.hex || "#ffffff";

      const textWrapper = document.createElement("div");
      textWrapper.style.display = "flex";
      textWrapper.style.flexDirection = "column";

      const mainText = document.createElement("span");
      mainText.className = "color-suggestion-text-main";
      mainText.textContent = color.name || "";

      const subText = document.createElement("span");
      subText.className = "color-suggestion-text-sub";
      subText.textContent = color.id || "";

      textWrapper.appendChild(mainText);
      if (color.id) {
        textWrapper.appendChild(subText);
      }

      if (color.availableForProduct === false) {
        mainText.textContent += " (nicht für dieses Produkt)";
        mainText.style.color = "#c0342b";
      }

      item.appendChild(swatch);
      item.appendChild(textWrapper);

      item.addEventListener("click", () => {
        searchInput.value = color.id || color.name || "";

        if (clearSearchButton) {
          clearSearchButton.classList.remove("hidden");
        }

        if (color.availableForProduct === false) {
          tempSelectedColor = null;
          if (modalSelectedColorInfo) {
            modalSelectedColorInfo.innerHTML = `
              <span class="color-unavailable-message">
                Dieser Farbton ist für das aktuell ausgewählte Produkt
                <strong>nicht verfügbar</strong>.<br>
                Bitte wähle einen anderen Farbton oder ein anderes Produkt.
              </span>
            `;
          }
          suggestionsContainer.classList.add("hidden");
          return;
        }

        tempSelectedColor = color;
        updatePreviews(color);
        updateModalSelectedColorInfo();
        updateProductSelectedColorInfo(color);

        renderColors(searchInput.value.trim());

        const allChips = document.querySelectorAll(".color-chip");
        allChips.forEach((c) => c.classList.remove("selected"));
        const targetChip = Array.from(allChips).find((chip) =>
          chip.title.includes(color.id || "") && chip.title.includes(color.name || "")
        );
        if (targetChip) {
          targetChip.classList.add("selected");
          targetChip.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        suggestionsContainer.classList.add("hidden");
      });

      suggestionsContainer.appendChild(item);
    });
  }

  /* ===========================
     Farbchips & Filter
     =========================== */

  function renderColors(searchQuery = "") {
    if (!colorList) return;
    colorList.innerHTML = "";

    const rawQ = searchQuery || "";
    const q = rawQ.toLowerCase();
    const qNorm = normalizeSearchString(rawQ);

    const filtered = colors.filter((color) => {
      const name = color.name || "";
      const id = color.id || "";
      const category = color.category || "";

      const nameLower = name.toLowerCase();
      const idLower = id.toLowerCase();

      const nameNorm = normalizeSearchString(name);
      const idNorm = normalizeSearchString(id);

      const matchesSearch =
        !q ||
        nameLower.includes(q) ||
        idLower.includes(q) ||
        nameNorm.includes(qNorm) ||
        idNorm.includes(qNorm);

      const matchesFamily = selectedFamily === "all" || color.family === selectedFamily;
      const matchesCategory = selectedCategory === "all" || category === selectedCategory;

      return matchesSearch && matchesFamily && matchesCategory;
    });

    filtered.forEach((color) => {
      const chip = document.createElement("div");
      chip.className = "color-chip";
      chip.style.backgroundColor = color.hex;
      chip.title = `${color.name} (${color.id})`;

      if (color.availableForProduct === false) {
        chip.classList.add("unavailable");
      }

      chip.addEventListener("click", () => {
        if (color.availableForProduct === false) {
          tempSelectedColor = null;
          if (modalSelectedColorInfo) {
            modalSelectedColorInfo.innerHTML = `
              <span class="color-unavailable-message">
                Dieser Farbton ist für das aktuell ausgewählte Produkt
                <strong>nicht verfügbar</strong>.<br>
                Bitte wähle einen anderen Farbton oder ein anderes Produkt.
              </span>
            `;
          }
          return;
        }

        tempSelectedColor = color;
        document.querySelectorAll(".color-chip").forEach((c) => c.classList.remove("selected"));
        chip.classList.add("selected");
        updatePreviews(color);
        updateModalSelectedColorInfo();
      });

      colorList.appendChild(chip);
    });

    if (filtered.length === 0) {
      colorList.innerHTML = "<p>Keine Farben gefunden.</p>";
    }
  }

  function renderCategories() {
    if (!categoryContainer) return;

    categoryContainer.innerHTML = "";

    const categories = Array.from(
      new Set(
        colors
          .map((c) => c.category)
          .filter((cat) => cat && typeof cat === "string")
      )
    );

    const allBtn = document.createElement("button");
    allBtn.textContent = "Alle";
    allBtn.className = "category-button active";
    allBtn.dataset.category = "all";
    categoryContainer.appendChild(allBtn);

    allBtn.addEventListener("click", () => {
      selectedCategory = "all";
      categoryContainer.querySelectorAll(".category-button").forEach((b) => b.classList.remove("active"));
      allBtn.classList.add("active");

      if (searchInput && searchInput.value.trim() !== "") {
        searchInput.value = "";
        renderSuggestions("");
        if (clearSearchButton) {
          clearSearchButton.classList.add("hidden");
        }
      }

      renderColors("");

      if (window.innerWidth <= 749) {
        mobileTabButtons.forEach((b) => b.classList.remove("active"));
        showMobileSection(null);
      }
    });

    categories.forEach((cat) => {
      const btn = document.createElement("button");
      btn.textContent = cat;
      btn.className = "category-button";
      btn.dataset.category = cat;
      btn.addEventListener("click", () => {
        selectedCategory = cat;
        categoryContainer.querySelectorAll(".category-button").forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");

        if (searchInput && searchInput.value.trim() !== "") {
          searchInput.value = "";
          renderSuggestions("");
          if (clearSearchButton) {
            clearSearchButton.classList.add("hidden");
          }
        }

        renderColors("");

        if (window.innerWidth <= 749) {
          mobileTabButtons.forEach((b) => b.classList.remove("active"));
          showMobileSection(null);
        }
      });
      categoryContainer.appendChild(btn);
    });
  }

  /* ===========================
     Mobile: Tabs / Bereiche
     =========================== */

  function showMobileSection(section) {
    if (window.innerWidth > 749) return;
    if (!modal || modal.classList.contains("hidden")) return;

    if (sidebarPanel) sidebarPanel.style.display = "none";
    if (previewPanel) previewPanel.style.display = "none";
    if (tonesPanel) tonesPanel.style.display = "block";

    if (toneFilterBlock) toneFilterBlock.style.display = "";
    if (collectionBlock) collectionBlock.style.display = "";

    if (!section) return;

    switch (section) {
      case "family":
        if (sidebarPanel) sidebarPanel.style.display = "block";
        if (toneFilterBlock) toneFilterBlock.style.display = "block";
        if (collectionBlock) collectionBlock.style.display = "none";
        if (tonesPanel) tonesPanel.style.display = "none";
        break;

      case "collections":
        if (sidebarPanel) sidebarPanel.style.display = "block";
        if (toneFilterBlock) toneFilterBlock.style.display = "none";
        if (collectionBlock) collectionBlock.style.display = "block";
        if (tonesPanel) tonesPanel.style.display = "none";
        break;

      case "preview":
        if (previewPanel) previewPanel.style.display = "block";
        if (tonesPanel) tonesPanel.style.display = "none";
        if (sidebarPanel) sidebarPanel.style.display = "none";
        break;

      case "full":
        if (expandToneBtn) {
          expandToneBtn.click();
        }
        break;
    }
  }

  /* ===========================
     Modal öffnen / schließen
     =========================== */

  function openModal() {
    document.body.classList.add("fh-colorpicker-open");

    hideChatWidget();
    hideTrustWidgets();
    startTrustObserver();

    modal.classList.remove("hidden");

    if (window.innerWidth <= 749) {
      mobileTabButtons.forEach((b) => b.classList.remove("active"));
      searchInput.classList.remove("visible");
      showMobileSection(null);
    }

    if (suggestionsContainer) {
      suggestionsContainer.classList.add("hidden");
      suggestionsContainer.innerHTML = "";
    }
  }

  function closeModal() {
    modal.classList.add("hidden");
    document.body.classList.remove("fh-colorpicker-open");

    showChatWidget();
    stopTrustObserver();
    showTrustWidgets();

    if (suggestionsContainer) {
      suggestionsContainer.classList.add("hidden");
      suggestionsContainer.innerHTML = "";
    }
  }

  openModalBtn.addEventListener("click", openModal);

  if (closeModalBtn) {
    closeModalBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      closeModal();
    });
  }

  modal.addEventListener("click", (e) => {
    if (!modalContent.contains(e.target)) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (toneFullscreenPopup && toneFullscreenPopup.classList.contains("visible")) {
        toneFullscreenPopup.classList.remove("visible");
        toneFullscreenPopup.classList.add("hidden");
      } else if (!modal.classList.contains("hidden")) {
        closeModal();
      }
    }
  });

  /* ===========================
     Buttons & Events
     =========================== */

  confirmBtn.addEventListener("click", () => {
    if (!tempSelectedColor) return;

    if (tempSelectedColor.availableForProduct === false) {
      if (modalSelectedColorInfo) {
        modalSelectedColorInfo.innerHTML = `
          <span class="color-unavailable-message">
            Dieser Farbton ist für das aktuell ausgewählte Produkt
            <strong>nicht verfügbar</strong>.<br>
            Bitte wähle einen anderen Farbton oder ein anderes Produkt.
          </span>
        `;
      }
      return;
    }

    updateProductSelectedColorInfo(tempSelectedColor);
    selectRadioButtonForColor(tempSelectedColor);
    closeModal();
  });

  if (resetColorButton) {
    resetColorButton.addEventListener("click", () => {
      setDefaultColor();
    });
  }

  toggleSearchButton.addEventListener("click", () => {
    if (window.innerWidth <= 749) {
      const isVisible = searchInput.classList.contains("visible");
      if (isVisible) {
        searchInput.classList.remove("visible");
        searchInput.blur();
      } else {
        searchInput.classList.add("visible");
        setTimeout(() => searchInput.focus(), 10);
      }
    } else {
      searchInput.focus();
    }
  });

  // Suche: beim Tippen → X anzeigen und Kollektion auf "Alle"
  searchInput.addEventListener("input", (e) => {
    const val = e.target.value;

    if (clearSearchButton) {
      if (val.trim() !== "") {
        clearSearchButton.classList.remove("hidden");
      } else {
        clearSearchButton.classList.add("hidden");
      }
    }

    if (val.trim() !== "") {
      selectedCategory = "all";
      if (categoryContainer) {
        const catButtons = categoryContainer.querySelectorAll(".category-button");
        catButtons.forEach((btn) => {
          btn.classList.toggle("active", btn.dataset.category === "all");
        });
      }
    }

    renderColors(val);
    renderSuggestions(val);
  });

  // X-Button: Suche löschen + alles anzeigen
  if (clearSearchButton) {
    clearSearchButton.addEventListener("click", () => {
      resetSearchAndShowAll();
      searchInput.focus();
    });
  }

  // Farbbereiche
  familyFilterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      familyFilterButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");
      selectedFamily = btn.dataset.family || "all";

      if (searchInput && searchInput.value.trim() !== "") {
        searchInput.value = "";
        renderSuggestions("");
        if (clearSearchButton) {
          clearSearchButton.classList.add("hidden");
        }
      }

      renderColors("");

      if (window.innerWidth <= 749) {
        mobileTabButtons.forEach((b) => b.classList.remove("active"));
        showMobileSection(null);
      }
    });
  });

  // Vorschau Tabs (Außen / Innen)
  previewTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      previewTabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      const target = tab.dataset.target;
      previewItems.forEach((item) => {
        if (item.id === target) {
          item.classList.remove("hidden");
        } else {
          item.classList.add("hidden");
        }
      });
    });
  });

  // Mobile Tabs (Farbbereich / Kollektionen / Vorschau / Vollfläche)
  mobileTabButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tab = btn.dataset.tab;
      const isActive = btn.classList.contains("active");

      if (isActive) {
        mobileTabButtons.forEach((b) => b.classList.remove("active"));
        showMobileSection(null);
      } else {
        mobileTabButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        showMobileSection(tab);
      }
    });
  });

  // Vollflächen-Popup
  if (expandToneBtn && toneFullscreenPopup && toneFullscreenClose) {
    expandToneBtn.addEventListener("click", () => {
      const color = (tonePreviewBox && tonePreviewBox.style.backgroundColor) || "#ffffff";
      toneFullscreenPopup.style.backgroundColor = color;
      toneFullscreenPopup.classList.remove("hidden");
      toneFullscreenPopup.classList.add("visible");
    });

    toneFullscreenClose.addEventListener("click", (e) => {
      e.stopPropagation();
      toneFullscreenPopup.classList.remove("visible");
      toneFullscreenPopup.classList.add("hidden");
    });

    toneFullscreenPopup.addEventListener("click", () => {
      toneFullscreenPopup.classList.remove("visible");
      toneFullscreenPopup.classList.add("hidden");
    });
  }

  /* ===========================
     Farben laden
     =========================== */

  fetch(COLORS_JSON_URL)
    .then((res) => res.json())
    .then((data) => {
      colors = data.map((c) => {
        const family = getColorFamily(c);
        const availableForProduct = isPriceGroupAvailableForProduct(c.priceGroup);

        return {
          ...c,
          family,
          availableForProduct
        };
      });

      renderCategories();
      renderColors();
    })
    .catch((err) => {
      console.error("Fehler beim Laden der Farben:", err);
    });

  if (!validateDOMElements()) return;
  setDefaultColor();
});
